import React from 'react';
import styles from '../css/comuns/Introducao.module.css';
import { config } from '../../data';

const Introducao = () => {
  return (
    <section className={styles['secao']}>
      <div className="container">
        <div className="row">
          <div className="col-md-8 mx-auto text-center">
            <h2 className={styles['texto-oni-azul']}>{config.texts.introducao.title}</h2>
            <p className="lead">{config.texts.introducao.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introducao;